import { Pipe, PipeTransform } from '@angular/core';
import { BaseUser } from '../entities';

@Pipe({
  name: 'name',
  standalone: true,
  pure: true,
})
export class NamePipe implements PipeTransform {
  public transform(user: BaseUser): string {
    return user.name ?? user.email ?? 'Unknown user';
  }
}
